import React, {useState, useEffect, useContext} from 'react';
import { Container, Row, Col } from 'reactstrap';
import classes from './Categorias.module.css';
import GlobalContext from '../../../context/GlobalContext';
import {getCategoriesPerMentor, getCategories, deleteMentorCategory, createMentorCategory} from '../../../helpers/Category.helper';

const Categorias = () => {

    const [isHidden, setIsHidden] = useState(true);
    const [mentorCategories, setMentorCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [categorySelected, setCategorySelected] = useState();

    const {setLoading} = useContext(GlobalContext);

    useEffect( () => {
        setLoading(true);
        getCategoriesPerMentor().then((d) => setMentorCategories(d));
        getCategories().then((d) => {
            setCategories(d);
            setCategorySelected(d[0].idCategoria);
            setLoading(false);
        });
    }, []);

    const deleteCategory = (idMentorCategory) => e =>{
        deleteMentorCategory(idMentorCategory).then(() => setMentorCategories(mentorCategories.filter(d => d.idCategoriaMentor !== idMentorCategory)));
    }

    const createCategory = () =>{
        createMentorCategory(categorySelected).then(() => getCategoriesPerMentor().then((d) => {
                setMentorCategories(d);
                setIsHidden(true);
                setCategorySelected(categories[0].idCategoria);

            }));
    }

    return(
        <>
        <Container>
            <Row>
                <Col className="title-container">
                    <div>
                        <h1>Categorías</h1>
                        <span>Categorías en las que me gustaría apoyar.</span>
                    </div>
                </Col>
            </Row>
        </Container>
        {
            (isHidden)?
            <Container>
                <Row>
                    <Col>
                        <div className={classes.addDispContainer}>
                            <button className={classes.button} onClick={()=>setIsHidden(false)}>+ Agregar categoría</button>
                        </div>

                        <Container className={classes.table}>
                            <Row className={classes.thead}>
                                <Col md="12"><span>Categoría</span></Col>
                            </Row>
                            {
                                mentorCategories.map((item, index) => (
                                    <Row id={"row" + index} className={classes.tbody} key={item.idCategoria}>
                                        <Col xs="9" md="10"><span>{item.sCategoria}</span></Col>
                                        <Col xs="3" md="2" className={classes.buttons}>
                                            <span onClick={deleteCategory(item.idCategoriaMentor)}>Eliminar</span>
                                        </Col>
                                    </Row>
                                ))
                            }
                        </Container>
                    </Col>
                </Row>
            </Container>
            :
            <Container style={{marginBottom: '50px'}}>
                <Row>
                    <Col>
                        <form>
                            <div className={classes.inputContainer}>
                                <label className={classes.text} htmlFor="genero">Área</label>
                                <select id="genero" className={classes.input} onChange={(e) => setCategorySelected(e.target.value)}>
                                    {
                                        categories.map((item, index)=>(
                                            <option value={item.idCategoria} key={item.idCategoria}>{item.sCategoria}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className={classes.saveButtons}>
                                <input type="button" onClick={createCategory} className={classes.buttonAddDisp} value="Agregar categoría"/>
                                <span className={classes.regresar} onClick={() => setIsHidden(true)}>Regresar a la lista</span>
                            </div>
                        </form>
                    </Col>
                </Row>
            </Container>
        }
        </>
    )
}
export default Categorias;
